import React from 'react'
import { NewActionInYourAreaMetadata } from '../../../types/notifications'
import { ImageCircle, NotificationRowProps, NotificationRowShell } from './notification-row-shell'

const NewActionInYourAreaRow = (props: NotificationRowProps) => {
  const meta = props.notification.metadata as Partial<NewActionInYourAreaMetadata> | undefined

  return (
    <NotificationRowShell
      {...props}
      avatar={<ImageCircle src={meta?.action_image} alt={meta?.action_name} />}
      destination={meta?.action_slug ? `/action/${meta.action_slug}` : undefined}
      highlights={[meta?.action_name, meta?.action_location]}
    />
  )
}

export default NewActionInYourAreaRow
